import { Tooltip } from 'antd';
import { getPopupContainer } from 'components/LightConversation/utils/popover';
import { useCopyText } from 'hooks/useCopyText';
import { Copy } from 'lucide-react';

/**
 * 主商品货号
 */
export const ProductInfoItemSku = ({ itemSku }: { itemSku: string }) => {
  const copyText = useCopyText();

  const handleClick = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation();
    copyText(itemSku);
  };

  return (
    <Tooltip title={itemSku} getPopupContainer={getPopupContainer}>
      <div
        className="group text-[12px] text-[var(--fett-text-tertiary)] cursor-pointer inline-flex items-center max-w-[120px]"
        onClick={handleClick}
      >
        <div className="flex-1 truncate">{itemSku}</div>
        <Copy
          size={11}
          className="mx-[1px] opacity-0 group-hover:opacity-100 transition-opacity duration-200"
        />
      </div>
    </Tooltip>
  );
};
